import React from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    show: boolean;
    deletableCount: number;
    skippedCount: number;
    onCancel: () => void;
    onConfirm: () => Promise<void> | void;
}

export const BulkDeleteInvoicesModal: React.FC<Props> = ({
    show,
    deletableCount,
    skippedCount,
    onCancel,
    onConfirm,
}) => (
    <ConfirmationModal
        show={show}
        onHide={onCancel}
        onReject={onCancel}
        onConfirm={onConfirm}
        title={`Delete ${pluralizeWithCount("draft invoice", deletableCount)}?`}
        question={
            skippedCount > 0
                ? `This can't be undone. ${pluralizeWithCount("selected invoice", skippedCount)} will be skipped because only manually created, imported, or MCP draft invoices can be deleted.`
                : "This can't be undone."
        }
        yes="Delete"
        yesBtnVariant="destructive"
        no="Cancel"
    />
);
